import { useCallback } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

import { useGenericSend } from './useGenericSend';

export const useSendVerificationEmail = () => {
    const send = useGenericSend();
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async (
        { sendMail = 1, template }: { sendMail?: number; template?: string }
    ): Promise<{ token?: string }> => {
        const { data } = await send<{ sendMail?: number; template?: string }, { token?: string }>({
            ID: 35559,
            responses: [35560, 35561],
            description: 'Create Email Token',
            sendMail,
            casinoName,
            ...template ? { template } : {}
        });

        return data;
    }, [send, casinoName]);
};
